import { Pressable, View } from 'react-native';
import { Text } from '@/components/ui/text';
import { useTranslation } from 'react-i18next';
import { ActivityLevel } from '~/graphql/generated/graphql';

const ACTIVITY_OPTIONS: ActivityLevel[] = [
  ActivityLevel.NotActive,
  ActivityLevel.LightlyActive,
  ActivityLevel.Active,
  ActivityLevel.VeryActive,
];

export interface ActivityLevelSelectorProps {
  selected: ActivityLevel | null | undefined;
  onSelect: (level: ActivityLevel) => void;
}

export const ActivityLevelSelector = ({
  selected,
  onSelect,
}: ActivityLevelSelectorProps) => {
  const { t } = useTranslation('user');

  return (
    <View className="flex flex-col xl:flex-row xl:flex-wrap gap-2">
      {ACTIVITY_OPTIONS.map((level) => {
        const isActive = selected === level;
        return (
          <Pressable
            key={level}
            onPress={() => onSelect(level)}
            className={`flex-row xl:flex-col items-center justify-between xl:justify-center xl:items-center xl:w-[calc(50%-4px)] gap-1 rounded-xl p-3.5 xl:py-3.5 xl:px-8 border ${
              isActive
                ? 'bg-accent-soft border-accent'
                : 'bg-surface-elevated border-transparent'
            }`}
          >
            <View className="flex-1 xl:flex-none xl:items-center gap-0.5">
              <Text className="text-sm font-medium text-foreground">
                {t(`settings.activityLevel.${level}`)}
              </Text>
              <Text className="text-xs text-text-muted">
                {t(`settings.activityLevel.${level}_DESC`)}
              </Text>
            </View>
            <View className="xl:hidden">
              <View
                className={`h-5 w-5 rounded-full border-2 items-center justify-center ${
                  isActive ? 'bg-accent border-accent' : 'border-text-muted'
                }`}
              >
                {isActive && (
                  <View className="h-2 w-2 rounded-full bg-background" />
                )}
              </View>
            </View>
          </Pressable>
        );
      })}
    </View>
  );
};
